import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { PartyPopper } from "lucide-react";
import { TapToPayGlyph, ttpLabel } from "./TapToPayButton";

/** Apple req 3.9: dedicated screen inviting the user to try Tap to Pay after
 *  T&C acceptance + device setup + education complete. */
export default function TapToPayTryIt({ open, onClose, onTry }) {
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="sm:max-w-sm" data-testid="ttp-tryit-dialog">
        <div className="flex flex-col items-center text-center gap-3 pt-4">
          <div className="w-16 h-16 rounded-full bg-emerald-500/15 flex items-center justify-center">
            <PartyPopper className="w-8 h-8 text-emerald-500" />
          </div>
          <DialogTitle className="text-xl">You're ready for {ttpLabel()}</DialogTitle>
          <DialogDescription className="text-sm">
            This phone is set up. Open an unpaid invoice and press the "{ttpLabel()}" button to take your first contactless payment.
          </DialogDescription>
        </div>
        <div className="space-y-2 pt-2">
          <Button
            onClick={() => { onClose(); onTry?.(); }}
            className="w-full h-11 bg-sky-600 hover:bg-sky-700 text-white font-semibold"
            data-testid="ttp-tryit-go-btn"
          >
            <TapToPayGlyph className="w-5 h-5 mr-2" /> Try it now
          </Button>
          <Button variant="ghost" onClick={onClose} className="w-full" data-testid="ttp-tryit-later">
            Later
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
